import { topics } from '@/mocks/homeMocks';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-800 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2 scroll-mt-20">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 mb-6">
            发现当下最受漫画迷关注的创作题材与风格标签
          </p>
          <div className="flex flex-wrap gap-3">
            {topics.map((topic) => (
              <a
                key={topic.id}
                href="#topics"
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${colorMap[topic.color] || colorMap.primary}`}
              >
                {topic.name}
                <span className="ml-2 text-xs opacity-70">{topic.heat}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}